import {
  CreditCardOutlined,
  HistoryOutlined,
  HomeOutlined,
  ShoppingOutlined,
  WifiOutlined,
} from '@ant-design/icons'
import type { ReactNode } from 'react'

export interface NavItem {
  key: string
  path: string
  labelKey: string
  icon: ReactNode
}

/**
 * Navigatsiya — BOR-YO'G'I besh bo'lim (vazifa hujjati: abonent uchun
 * zichlik emas, tezkorlik kerak). Shu ro'yxat ikkalasiga ham xizmat qiladi:
 * mobil pastki tab-bar va desktop header menyusi — ikki nusxa yozilsa,
 * biri unutilib, ikkisi bir-biriga mos kelmay qolardi.
 */
export const NAV_ITEMS: NavItem[] = [
  { key: 'dashboard', path: '/', labelKey: 'nav.dashboard', icon: <HomeOutlined /> },
  { key: 'plans', path: '/plans', labelKey: 'nav.plans', icon: <ShoppingOutlined /> },
  { key: 'usage', path: '/usage', labelKey: 'nav.usage', icon: <WifiOutlined /> },
  { key: 'sessions', path: '/sessions', labelKey: 'nav.sessions', icon: <HistoryOutlined /> },
  { key: 'payments', path: '/payments', labelKey: 'nav.payments', icon: <CreditCardOutlined /> },
]

/** Joriy yo'lga mos elementni topadi — eng UZUN mos yo'l g'olib chiqadi */
export function findActiveNavKey(pathname: string): string {
  let best: NavItem | null = null
  for (const item of NAV_ITEMS) {
    const matches = item.path === '/' ? pathname === '/' : pathname.startsWith(item.path)
    if (matches && (!best || item.path.length > best.path.length)) {
      best = item
    }
  }
  return best?.key ?? 'dashboard'
}
